import {Center, Loader} from '@mantine/core';

export const ReportsLoading = () => (
    <Center h={300}>
        <Loader />
    </Center>
);
